"use client";

import { withFallback } from "../with-fallback";

export const ChangeAccountCountryElement = withFallback({
	displayName: "ChangeAccountCountryElement",
	type: "change-account-country-element",
} as const);
